import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AlbumState } from '../../../data/models/albumState';
import './RejectionModal.scss';
import { Modal } from '../Modal';
import useProductStateTransition from '../../../hooks/useProductStateTransition';
import { FormatType } from '@/data/models/formatType';
import {
  merchandiseSubmissionsGridUrl,
  submissionsGridUrl,
} from '../Grid/GridUtilities';

interface Props {
  albumId: string;
  albumTitle: string;
  showModal: boolean;
  formatType?: FormatType;
  setShowModal: (showModal: boolean) => void;
}
const RejectionModal = ({
  albumId,
  albumTitle,
  showModal,
  formatType,
  setShowModal,
}: Props) => {
  const { t } = useTranslation();
  const [rejectionNote, setRejectionNote] = useState<string>();
  const { updateProductState } = useProductStateTransition(
    formatType === FormatType.Merchandise
      ? merchandiseSubmissionsGridUrl
      : submissionsGridUrl
  );

  const handleReject = async () => {
    await updateProductState({
      albumId,
      albumTitle,
      newState: AlbumState.Rejected,
      notes: rejectionNote,
    });
    handleClose();
  };
  const handleClose = () => {
    setRejectionNote('');
    setShowModal(false);
  };
  return (
    <Modal
      titleText={t('product.rejectionModal.header')}
      submitButtonText={t('productActions.button.reject')}
      show={showModal}
      submitButtonDisabled={false}
      onClose={handleClose}
      onSubmit={handleReject}
    >
      <div className="confirmation-body">
        <label className="form-label">{t('product.rejectionModal.body')}</label>
        <textarea
          className="form-control rejection-notes-textarea"
          maxLength={1000}
          value={rejectionNote}
          placeholder={t('product.rejectionModal.notesPlaceholder')}
          onChange={(e) => {
            setRejectionNote(e.target.value);
          }}
        ></textarea>
        <span>{`${rejectionNote?.length ?? 0}/1000`}</span>
      </div>
    </Modal>
  );
};

export default RejectionModal;
